export default __webpack_public_path__ + "static/media/singpass-login-btn.7163ca76.svg";